export const REPORTS_FEATURE = {
  NAME: 'Reports',
  PATH: 'reports',
};
